import { axios } from "helpers";

export const confirmationService = {
	cancelEmailChange,
	confirmEmailChange,
};

const API_URL = process.env.REACT_APP_API_URL;

function cancelEmailChange({ token }) {
	const requestOptions: any = {
		url: `${API_URL}/api/cancel_email_change`,
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		params: {
			token,
		},
	};
	return axios(requestOptions).then(res => res.data);
}

function confirmEmailChange({ token }) {
	const requestOptions: any = {
		url: `${API_URL}/api/confirm_email_change`,
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		params: {
			token,
		},
	};
	return axios(requestOptions).then(res => res.data);
}
